import { render } from "./TheCatalog.vue?vue&type=template&id=10f07c50&scoped=true&lang=pug&bindings={\"items\":\"setup\",\"title\":\"setup\",\"changeModalStatus\":\"setup\",\"className\":\"setup\",\"el\":\"setup\",\"show\":\"setup\"}"
import script from "./TheCatalog.vue?vue&type=script&lang=js"
export * from "./TheCatalog.vue?vue&type=script&lang=js"

import "./TheCatalog.vue?vue&type=style&index=0&id=10f07c50&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-10f07c50"

export default script